import React, { Component } from 'react';
import { Route, Redirect, Switch } from 'react-router';
import PageHeader from '../../../../components/PageHeader';
import PageMenu from '../../../../components/PageMenu';
import PageMenuItem from '../../../../components/PageMenuItem';
import { hasPermission, hasOneOfPermissions } from '../../../../utility/account';
import { withRouter } from 'react-router';
import { withUser } from '../../../../utility/withUser';

// Screens.
import AutoReplies from './screens/AutoReplies';
import Days from './screens/Days';
import Users from './screens/Users';
import Profile from './screens/Profile';
import StandardTexts from './screens/StandardTexts';
import Tags from './screens/Tags';
import Export from './screens/Export';

/**
 * Screen for showing the settings page.
 *
 * @extends React.Component
 */
class Settings extends Component {
  /** @inheritdoc */
  constructor(props) {
    super(props);
    this.state = {
      autoRepliesAllowed: null,
      usersAllowed: null,
      daysAllowed: null,
      standardTextsAllowed: null,
      tagsAllowed: null,
      exportAllowed: null,
    }
  }

  /**
   * Fetch permission to auto replies menu.
   */
  fetchAutoRepliesAllowedPermission = () => {
    hasPermission(this.props.user.id, "get all auto replies", this.props.token, this.props.history, (allowed) => {
      this.setState({autoRepliesAllowed: allowed});
    });
  }

  /**
   * Fetch permission to users menu.
   */
  fetchUsersAllowedPermission = () => {
    hasOneOfPermissions(this.props.user.id, ["get all users", "get admin users", "get supervisor users", "get advisor users"], this.props.token, this.props.history, (allowed) => {
      this.setState({usersAllowed: allowed});
    });
  }

  /**
   * Fetch permission to days menu.
   */
  fetchDaysAllowedPermission = () => {
    hasPermission(this.props.user.id, "get all days", this.props.token, this.props.history, (allowed) => {
      this.setState({daysAllowed: allowed});
    });
  }

  /**
   * Fetch permission to standard texts menu.
   */
  fetchStandardTextsAllowedPermission = () => {
    hasOneOfPermissions(this.props.user.id, ["get all user standard texts", "get own user standard texts"], this.props.token, this.props.history, (allowed) => {
      this.setState({standardTextsAllowed: allowed});
    });
  }

  /**
   * Fetch permission to tags menu.
   */
  fetchTagsAllowedPermission = () => {
    hasPermission(this.props.user.id, "get all tags", this.props.token, this.props.history, (allowed) => {
      this.setState({tagsAllowed: allowed});
    });
  }

  /**
   * Fetch permission to export menu.
   */
  fetchExportAllowedPermission = () => {
    hasPermission(this.props.user.id, "export all conversations", this.props.token, this.props.history, (allowed) => {
      this.setState({exportAllowed: allowed});
    });
  }

  /** @inheritdoc */
  componentDidMount = () => {
    this.fetchAutoRepliesAllowedPermission();
    this.fetchUsersAllowedPermission();
    this.fetchDaysAllowedPermission();
    this.fetchStandardTextsAllowedPermission();
    this.fetchTagsAllowedPermission();
    this.fetchExportAllowedPermission();
  }

  render() {
    return (
      <div className="container-fluid">
        <PageHeader label="Indstillinger" />
        <div className="row">
          <PageMenu header="Vælg område">
            <PageMenuItem label="Din profil" href={`${this.props.match.path}/profile`} />
            {this.state.usersAllowed && <PageMenuItem label="Brugere" href={`${this.props.match.path}/users`} />}
            {this.state.autoRepliesAllowed && <PageMenuItem label="Autosvar" href={`${this.props.match.path}/auto-replies`} />}
            {this.state.daysAllowed && <PageMenuItem label="Åbningstider" href={`${this.props.match.path}/days`} />}
            {this.state.standardTextsAllowed && <PageMenuItem label="Standardtekster" href={`${this.props.match.path}/standard-texts`} />}
            {this.state.tagsAllowed && <PageMenuItem label="Tags" href={`${this.props.match.path}/tags`} />}
            {this.state.exportAllowed && <PageMenuItem label="Eksporter data" href={`${this.props.match.path}/export`} />}
          </PageMenu>
          <div className="col-sm-9">
            <div className="tab-content" id="nav-tabContent">
              <Switch>
                <Redirect exact from={`${this.props.match.path}`} to={`${this.props.match.path}/profile`} />
                <Route exact path={`${this.props.match.path}/auto-replies`} component={AutoReplies} />
                <Route exact path={`${this.props.match.path}/days`} component={Days} />
                <Route path={`${this.props.match.path}/users`} component={Users} />
                <Route exact path={`${this.props.match.path}/profile`} component={Profile} />
                <Route exact path={`${this.props.match.path}/standard-texts`} component={StandardTexts} />
                <Route exact path={`${this.props.match.path}/tags`} component={Tags} />
                <Route exact path={`${this.props.match.path}/export`} component={Export} />
              </Switch>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(withUser(Settings));



// WEBPACK FOOTER //
// ./src/screens/AdvisoryApp/screens/Settings/index.js